const initialState: string[] = [];

export default initialState;
